import { format } from "date-fns";

import { DatatableColumnHeader } from "@/components/_molecules/datatable/datatable-column-header";
import i18n from "@/lib/i18n";
import { stringFromFileSize } from "@/lib/stringFromFileSize";
import { ColumnDef } from "@tanstack/react-table";

import { FileDownloader } from "../file-downloader";
import { FileScanStatusBadge } from "../file-scan-status-badge";

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
import { File } from "./model";
import { DatatableRowActions } from "./row-actions";

export const getColumns = ({ isReadOnly }: { isReadOnly: boolean }): ColumnDef<File>[] => {
  return [
    {
      id: "name",
      accessorKey: "name",
      enableHiding: false,
      size: 400,
      header: ({ column }) => <DatatableColumnHeader column={column} title={i18n.t("fileDatatable.name", { ns: "common" })} />,
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          {row.original.scanStatus === "CLEAN" ? (
            <FileDownloader file={row.original} mode="OPEN">
              {row.original.name}
            </FileDownloader>
          ) : (
            <span className="text-sm text-muted-foreground">{row.original.name}</span>
          )}
          <FileScanStatusBadge scanStatus={row.original.scanStatus} />
        </div>
      ),
    },
    {
      id: "size",
      accessorKey: "size",
      accessorFn: (original) => {
        return stringFromFileSize(original.size, true);
      },
      header: ({ column }) => <DatatableColumnHeader column={column} title={i18n.t("fileDatatable.fileSize", { ns: "common" })} />,
    },
    {
      id: "updatedAt",
      accessorKey: "updatedAt",
      accessorFn: (original) => {
        return format(new Date(original.createdAt), "yyyy-MM-dd");
      },
      header: ({ column }) => <DatatableColumnHeader column={column} title={i18n.t("fileDatatable.lastModified", { ns: "common" })} />,
    },
    {
      id: "createdAt",
      accessorKey: "createdAt",
      accessorFn: (original) => {
        return format(new Date(original.createdAt), "yyyy-MM-dd");
      },
      header: ({ column }) => <DatatableColumnHeader column={column} title={i18n.t("fileDatatable.addedAt", { ns: "common" })} />,
    },
    {
      id: "actions",
      cell: ({ row }) => <DatatableRowActions row={row} file={row.original} isReadOnly={isReadOnly} />,
    },
  ];
};
